export const MODALS_NAME = {
    ACHIEVEMENT: 'achievement',
    CASHBACK: 'cashback',
    CASHIER: 'cashier',
    DELETE_PROFILE: 'delete-profile',
    DEMO_LIMITS: 'demo-limits',
    DEPOSIT_SURVEY: 'deposit-survey',
    EMAIL_CONFIRMED: 'email-confirmed',
    INTRO: 'intro',
    ORDER_UPDATE: 'update-order',
    PARTNER_ADD_POSTBACK: 'partner-add-postback',
    PARTNER_UPDATE_POSTBACK: 'partner-update-postback',
    PERSONAL: 'personal',
    POSITION_UPDATE: 'update-position',
    PROMOCODE_HELLO_JETVIX: 'promocode-hello-jetvix',
    LEADERBOARD_NOTIFICATION_LEAGUE: 'leaderboard-notification-league',
    REFILL: 'refill',
    REFERRAL_GIFT_REWARD: 'referral-gift-reward',
    REFERRAL_WARNING_RESET_PROGRESS: 'referral-warning-reset-progress',
    REFERRAL_SHARE_LINK: 'referral-share-link',
    REFERRAL_SHARE_QR_CODE: 'referral-share-qr-code',
    REFERRAL_RESPAWN_TIMER: 'referral-respawn-timer',
    REQUEST_FEEDBACK: 'request-feedback',
    RESET_PASSWORD: 'reset-password',
    RESPAWN: 'respawn',
    RESPAWN_MOTIVATION: 'respawn-motivation',
    RESPAWN_STATUS: 'respawn-status',
    REFERRAL_RECEIVED_REWARD: 'referral-received-reward',
    STATUS_CONGRATULATIONS: 'status-congratulations',
    USER_STATE_INFORMATION: 'user-state-information',
    USER_STATUSES: 'user-statuses',
    VERIFY_REQUEST: 'verify-request',
    WITHDRAWAL_CANCEL: 'withdrawal-cancel',
    WITHDRAWAL_LIMITS: 'withdrawal-limits',
} as const;
